import React from 'react'
import TimeInput from '../../../../Components/TimeInput'

export function ScheduleEditor({ title, scheduleType, schedule, daysOfWeek, onScheduleChange }) {
  return (
    <div className="bg-white shadow rounded-lg overflow-hidden">
      <div className="px-4 py-5 sm:px-6 border-b border-gray-200">
        <h3 className="text-lg font-medium text-gray-900">{title}</h3>
        <p className="mt-1 text-sm text-gray-500">Set the hours for each day of the week</p>
      </div>
      <div className="px-4 py-5 sm:p-6">
        <table className="min-w-full divide-y divide-gray-200">
          <thead>
            <tr>
              <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Day</th>
              <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Open</th>
              <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Close</th>
              <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Closed</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {daysOfWeek.map((day) => {
              const daySchedule = schedule[day] || {}
              const isClosed = daySchedule.closed === true || daySchedule.closed === 'true'

              return (
                <tr key={day}>
                  <td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-900 capitalize">
                    {day}
                  </td>
                  <td className="px-3 py-4 whitespace-nowrap">
                    <TimeInput
                      value={daySchedule.open_at}
                      onChange={(e) => onScheduleChange(scheduleType, day, 'open_at', e.target.value)}
                      disabled={isClosed}
                    />
                  </td>
                  <td className="px-3 py-4 whitespace-nowrap">
                    <TimeInput
                      value={daySchedule.close_at}
                      onChange={(e) => onScheduleChange(scheduleType, day, 'close_at', e.target.value)}
                      disabled={isClosed}
                    />
                  </td>
                  <td className="px-3 py-4 whitespace-nowrap">
                    <input
                      type="checkbox"
                      checked={isClosed}
                      onChange={(e) => onScheduleChange(scheduleType, day, 'closed', e.target.checked)}
                      className="h-4 w-4 rounded border-gray-300 text-sky-600 focus:ring-sky-500"
                    />
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
